import React, { FC } from "react";
import { FieldStatus } from "../../Helpers/FieldStatus";
import {Button} from "../../Button/Button";
import classNames from "classnames";

export enum SubmitType {
  next = "next",
  submit = "submit",
}

interface SubmitProps {
  status?: FieldStatus;
  type?: SubmitType;
  label?: string;
  className?: string;
};

const submitText = {
  next: "Neste",
  submit: "Bekreft timebestilling",
};

export const Submit: FC<SubmitProps> = ({
  type = SubmitType.next,
  status = FieldStatus.active,
  label = undefined,
  className,
  children,
}) => {
  return (
    <Button
      size="large"
      disabled={status == FieldStatus.disabled}
      fullWidth
      className={classNames("Submit", className)}
    >
      {children || label || submitText[type]}
    </Button>
  );
};
